export default __webpack_public_path__ + "static/media/face_2_53.def1f93b.png";